<template>
  <div v-if="showFlag" class="about-page">
    <van-sticky>
      <van-nav-bar :title="detail.name" left-arrow @click-left="goBack" />
    </van-sticky>
    <div class="page-main" v-html="detail.content">
    </div>
    <div class="footer">
      <div class="footer-content">
        <van-button
          @click="goBack"
          type="primary"
          round
          block
          color="linear-gradient(to right, #FB993A, #ffa882)"
          >关闭</van-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { fetchByCode } from '../../api/rich-text'
export default {
  data() {
    return {
      detail: {},
      showFlag: false
    };
  },
  methods: {
    show(code) {
      fetchByCode(code).then(res => {
        this.detail = res
        this.showFlag = true
      })
    },
    goBack() {
      this.showFlag = false
    },
  },
};
</script>

<style scoped lang="less">
.about-page {
  background: #fff;
  position: fixed;
  top: 0;
  bottom: 0;
  width: 100%;
  z-index: 9999;
  overflow-y: scroll;
  .content {
    padding: 20px 14px;
    .section {
      font-size: 14px;
      line-height: 26px;
      margin-bottom: 8px;
      span {
        display: inline-block;
        width: 24px;
      }
    }
  }
  .page-main {
    font-size: 0.38rem;
    padding: 40px 40px 80px 40px;
    /deep/ img {
      margin: 0;
    }
    .page-title {
      // text-align: center;
      // line-height: 45px;
      // font-size: 12px;
    }
    .page-item {
      background: #fff8ee;
      border: 1px solid #f3b25c;
      padding: 0px 10px 10px;
      border-radius: 5px;
      line-height: 30px;
      font-size: 14px;
      margin-bottom: 20px;
      .page-item-header {
        text-align: center;
        img {
          border-radius: 50%;
          width: 100px;
          height: 100px;
        }
        .page-item-title {
          font-size: 13px;
          font-weight: 500;
          // line-height:20px;
        }
      }
      .page-item-content {
        display: flex;
        .page-item-point {
          width: 15px;
        }
        .page-item-text {
          width: calc(~"100% - 15px");
        }
        // border: 1px solid #f1f1f1;
      }
    }
  }
}
.footer {
  z-index: 9999;
  width: 100%;
  background: #ffffff;
  position: fixed;
  bottom: 0;
  border-top: 1px solid #f8f8f8;
  .footer-content {
    padding: 10px 14px;
    // display: flex;
    .van-button--round {
      border-radius: 5px;
    }
  }
}
</style>
